// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"484":"84ba4388","621":"cab6a8a4"}[chunkId] + ".chunk.css";
};